export default __webpack_public_path__ + "static/Photo 2 (2)-78b18b1eca07b182866ce7c8e52cff69.png";